<template>
  <div class="flex-column a-center j-center bg-white">
    <span class="ai-animate main-txt" swiper-animate-effect="fadeInDown" swiper-animate-delay="0" swiper-animate-speed="1_5">外研优学</span>
    <span class="ai-animate sub-txt text-center m-t-30" swiper-animate-effect="fadeInDown" swiper-animate-delay="0_5" swiper-animate-speed="1_5">
      外研优学，专注K12教育，依托北京外国语大学优质资源，汇聚学科、专家、教研优势，结合人工智能大数据和语音<br>
      评测技术，打造权威、专业的英语听说教学一站式解决方案</span>
    <div class="ai-animate w-600 h-400 m-t-40 media-box flex a-center j-center" swiper-animate-effect="fadeIn" swiper-animate-delay="1_5" swiper-animate-speed="1_5">
      <div class="media" @click="mediaClickHandler()">
        <div class="controls flex a-center j-center">
          <v-icon v-show="mediaPaused" :scale="4" name="play-circle"/>
        </div>
        <video id="wy-media-video" ref="media_player" playsinline poster="../assets/posterSrc.png" src="../assets/mediaSrc.mp4"/>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  props: {
    isPlay: Boolean
  },
  watch: {
    isPlay (isPlay) {
      if (isPlay) {
        this.$refs.media_player.load()
        this.play()
      } else {
        this.pause()
      }
    }
  },
  data () {
    return {
      mediaPaused: !this.isPlay
    }
  },
  methods: {
    mediaClickHandler () {
      if (this.$refs.media_player.paused) {
        this.play()
      } else {
        this.pause()
      }
    },
    play () {
      this.mediaPaused = false
      this.$refs.media_player.play()
      _hmt.push(['_trackEvent', 'tingshuo-service','play', 'tingshuo-video'])
    },
    pause () {
      this.mediaPaused = true
      this.$refs.media_player.pause()
      _hmt.push(['_trackEvent', 'tingshuo-service','pause', 'tingshuo-video'])
    }
  }
}
</script>

<style lang="scss" scoped>
.main-txt {
  font-size: 36px;
  font-weight: 500;
}

.sub-txt {
  font-size: 18px;
  font-weight: 400;
  line-height: 40px;
}

.media-box {
  background: url(../assets/module-2.png) no-repeat center center;
  background-size: contain;
  .media {
    width: 464px;
    height: 270px;
    margin-top: -10px;
    padding: 10px;
    position: relative;
    video {
      width: 100%;
      height: 100%;
    }
    .controls {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100px;
      height: 100px;
      transform: translateY(-50%) translateX(-50%);
      * {
        color: rgba(0, 0, 0, .8)
      }
    }
  }
}
@media (max-width: 767px) {
  .main-txt {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .sub-txt {
    font-size: 16px;
    margin-bottom: 10px;
    padding: 0 30px;
    line-height: 24px;
  }
  .w-600 {
    width: 100%;
  }
  .h-400 {
    height: auto;
    margin-bottom: 40px;
  }
  .media-box {
    background: url(../assets/module-2.png) no-repeat center center;
    background-size: contain;
    .media {
      width: auto;
      height: 192px;
      video {
        width: auto;
        height: 80%;
        margin-top: 20px
      }
    }
  }
}
</style>
